"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const safeRest = (_a) => {
    var { style, className } = _a, props = tslib_1.__rest(_a, ["style", "className"]);
    return props;
};
exports.default = safeRest;
//# sourceMappingURL=safeRest.js.map